import { render, staticRenderFns } from "./aiStudyList.vue?vue&type=template&id=7f082b88"
import script from "./aiStudyList.vue?vue&type=script&lang=js"
export * from "./aiStudyList.vue?vue&type=script&lang=js"
import style0 from "./aiStudyList.vue?vue&type=style&index=0&id=7f082b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports